import { MaterialReactTable, MRT_GlobalFilterTextField, useMaterialReactTable } from 'material-react-table';
import { Box, lighten, Stack } from '@mui/material';
import { KeyboardArrowRight } from '@mui/icons-material';
import { calculateAverage, calculateAverageTwo } from '@/utils/calculateTotalTable';

const TableBasicAnaliseDescontos = ({ data }) => {
  const columns = [
    {
      id: 'action',
      header: '',
      Cell: () => (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '30px' }}>
          <KeyboardArrowRight />
        </Box>
      ),
      size: 20,
    },
    {
      accessorKey: 'name',
      header: 'Etapas',
      sortDescFirst: true,
      enableMultiSort: true,
      size: 50,
      Footer: () => (
        <Stack>
          <Box>Total</Box>
        </Stack>
      ),
    },
    {
      accessorKey: 'medium_discount',
      header: '% Descontos',
      size: 20,
      Cell: ({ renderedCellValue }) => (
        <div style={{ textAlign: 'center' }}>{renderedCellValue} %</div>
      ),
      Footer: () => (
        <Stack>
          <Box sx={{ color: '#000', fontWeight: 600 }}>{calculateAverage(data, 'medium_discount')}</Box>
        </Stack>
      ),
    },
    {
      accessorKey: 'score',
      header: 'Score',
      size: 50,
      Cell: ({ renderedCellValue }) => (
        <div
          style={{
            background: '#E04A4C',
            color: '#fff',
            fontWeight: 600,
            textAlign: 'center',
            borderRadius: '5px',
            padding: '5px',
          }}
        >
          {renderedCellValue}
        </div>
      ),
      Footer: () => (
        <Stack>
          <Box sx={{ color: '#000', fontWeight: 600 }}>{calculateAverageTwo(data, 'score')}</Box>
        </Stack>
      ),
    },
  ];

  const tableBasic = useMaterialReactTable({
    columns,
    data,
    positionActionsColumn: 'last',
    enableColumnFilterModes: false,
    enableColumnOrdering: false,
    enableGrouping: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableHiding: false,
    enableExpandAll: false,
    enableRowDragging: false,
    enableColumnActions: false,
    enableBottomToolbar: false,
    initialState: {
      showGlobalFilter: true,
    },
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
    },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [10, 20, 30],
      shape: 'rounded',
      variant: 'outlined',
    },
    muiTableHeadCellProps: ({ column }) => ({
      sx: {
        color: 'black',
        fontWeight: 400,
        fontSize: '12px',
      },
    }),
    muiTableBodyCellProps: ({ column }) => ({
      sx: {
        backgroundColor: '#fff',
        color: 'rgba(128, 128, 128, 1)',
        fontWeight: 400,
        fontSize: '12px',
      },
    }),
    renderTopToolbar: ({ table }) => (
      <Box
        sx={(theme) => ({
          backgroundColor: lighten(theme.palette.background.default, 0.05),
          display: 'none',
          gap: '0.5rem',
          p: '8px',
          justifyContent: 'space-between',
          border: '1px solid red',
        })}
      >
        <Box sx={{ borderRadius: '20px' }}>
          <MRT_GlobalFilterTextField table={table} />
        </Box>
      </Box>
    ),
  });

  return (
    <Box sx={{
      minHeight: '600px',
      maxHeight: '600px',
      overflowY: 'auto',
      boxShadow: '0px 8px 10px 0px #00000040',

      borderRadius: '5px',

      scrollBehavior: 'smooth', // Add smooth scrolling
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: '#555',
      },
    }}>
      <MaterialReactTable table={tableBasic} />
    </Box>
  );
};

export default TableBasicAnaliseDescontos;
